exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2L9gRWTYfkYaG8FgxoWGU7 {\n    background-color: #EEEEEF;\n    border-radius: 24px;\n    font-weight: 400;\n    font-style: Italic;\n    font-size: 18px;\n    line-height: 36px;\n    letter-spacing: 0.5px;\n    display: grid;\n    height: 219px;\n    width: 396px;\n    padding: 38px 28px;\n}\n\n._2L9gRWTYfkYaG8FgxoWGU7::before {\n    content: \"\\201C\";\n    font-size: 11rem;\n    position: relative;\n    right: 28px;\n    bottom: 34px;\n    height: 0;\n    color: #ACACB1DE;\n}\n", ""]);

// exports
exports.locals = {
	"root": "_2L9gRWTYfkYaG8FgxoWGU7"
};